import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import ShareRoutes from './ShareRoutes';


export default function ThemeRoutes() {
    return useRoutes([MainRoutes, ...ShareRoutes]);
}
